import type { BaseKeyFunction, UseRequestQueryProps } from "@packages/sdk";
import { useRequestQuery } from "@packages/sdk";
import { z } from "zod";

const generateStudentUsernameKey: BaseKeyFunction<{
  name: string;
  last_name: string;
}> = ({ name, last_name }) => ["generate-username", name, last_name];

export const useRequestGenerateStudentUsername = ({
  name,
  last_name,
  ...props
}: UseRequestQueryProps & {
  last_name: string;
  name: string;
}) =>
  useRequestQuery({
    ...props,
    queryFnRequestProps: {
      urlBackendPath: `/username/generate?name=${encodeURIComponent(name)}&last_name=${encodeURIComponent(last_name)}`,
      schema: z.object({ username: z.string() }),
    },
    queryKey: generateStudentUsernameKey({ name, last_name }),
  });
